import { html, render } from 'lit-html/lib/lit-extended';
import { TemplateResult } from 'lit-html';
import { Property } from './decorators';
class Seed extends HTMLElement {
    constructor() {
        super();
        this._connected = false;
        this.attachShadow({ mode: 'open' });
    }
    /** The component instance has been inserted into the DOM. */
    connectedCallback() {
        this._connected = true;
        this.upgradeProperties();
        this.upgradePropertyAttributes();
        this.render();
    }
    /** The component instance has been removed from the DOM. */
    disconnectedCallback() {
        this._connected = false;
    }
    /** Rerender when the observed attributes change. */
    attributeChangedCallback(_name, _oldValue, _newValue) {
        this.render();
    }
    /** Render the component. */
    render() {
        if (this._connected) {
            render(this._template, this.shadowRoot);
        }
    }
    /** Helper to query the rendered shadowRoot with querySelector. `this.$('div.actions')` */
    $(selectors) {
        return this.shadowRoot.querySelector(selectors);
    }
    /** Helper to query the rendered shadowRoot with querySelectorAll. `this.$$('div.actions')` */
    $$(selectors) {
        return this.shadowRoot.querySelectorAll(selectors);
    }
    /** Combine the components styles and template. */
    get _template() {
        return html `
    <style>
      :host {
        display: block;
      }

      :host([hidden]) {
        display: none;
      }
    </style>
    ${this.styles}
    ${this.template}
    <!-- Built, tested, and published with Nutmeg. https://nutmeg.tools -->
    `;
    }
    /** Support lazy properties https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties */
    upgradeProperties() {
        const instance = this;
        const props = (instance).constructor['observedAttributes'].concat((instance).constructor['observedProperties']);
        props.forEach((prop) => {
            if (instance.hasOwnProperty(prop)) {
                let value = (instance)[prop];
                delete (instance)[prop];
                (instance)[prop] = value;
            }
        });
    }
    /** Perform a one-time upgrade of complex properties from JSON encoded attributes. */
    upgradePropertyAttributes() {
        const instance = this;
        (instance).constructor['observedProperties'].forEach((prop) => {
            if (instance.hasAttribute(prop)) {
                (instance)[prop] = JSON.parse(instance.getAttribute(prop));
                instance.removeAttribute(prop);
            }
        });
    }
}
Seed.observedProperties = [];
Seed.observedAttributes = [];
export { Seed, html, Property as Prop, Property, TemplateResult, };
//# sourceMappingURL=seed.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nutmeg/seed/dist/seed.js
// module id = ./node_modules/@nutmeg/seed/dist/seed.js
// module chunks = 0 1